import { ref } from 'vue';
import type { Airflow } from '@aviata/platform-types';

import { sentryModel } from '@/shared/model';

import { savePassengersApi } from './api';

export function useSavePassengers() {
  const isLoading = ref(false);

  function savePassengers(
    offerId: string,
    passengers: Airflow.Order.Payload.Entity['passengers'],
  ) {
    isLoading.value = true;
    return savePassengersApi
      .savePassengers(offerId, passengers)
      .catch(error => {
        sentryModel.captureException(
          sentryModel.getReadableError(
            'AVIA_ERR_FAILED_FAILED_TO_SAVE_PASSENGERS',
            error,
          ),
          { level: sentryModel.level.FATAL },
        );
        throw error;
      })
      .finally(() => (isLoading.value = false));
  }

  return { isLoading, savePassengers };
}
